import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import {
  Button,
  Modal,
  Space,
  Table,
  message,
  Select,
  Input,
  Row,
  Col,
} from "antd";
import { ExclamationCircleFilled, DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import Createseller from "./components/Createclient";
import Editseller from "./components/Editclient";
import ExportClientsToExcel from "./components/ExportClientsToExcel";
import { deleteUser, readUsers, readItems, aggregate } from "@directus/sdk";
import { QRCode } from "antd";
import ReactDOM from "react-dom/client";

import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {  ObtenerUsuariosClientesPorSuperior } from "../../services/usuarios";

const Clients = (props) => {
  const [datasellers, setDatasellers] = useState([]);
  const [opencreate, setOpencreate] = useState(false);
  const [openupdate, setOpenupdate] = useState(false);
  const [selectseller, setSelectseller] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isExportingExcel, setIsExportingExcel] = useState(false);

  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const [circuits, setCircuits] = useState([]);
  const [selectedCircuit, setSelectedCircuit] = useState(null);
  const [filteredClients, setFilteredClients] = useState([]);

  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchName, setSearchName] = useState("");

  const [aliados, setAliados] = useState([]);
  const [selectedAliado, setSelectedAliado] = useState(null);
  const [loadingByAliado, setLoadingByAliado] = useState(false);

  const downloadSelectedQRs = async () => {
    if (selectedRowKeys.length === 0) {
      Modal.warning({
        title: "Selección vacía",
        content:
          "Por favor, seleccione al menos un cliente para descargar sus códigos QR.",
      });
      return;
    }

    setIsDownloading(true);
    try {
      const directus = await getDirectusClient();
      
      // Obtener los clientes seleccionados con todos los datos necesarios
      const selectedClientsResponse = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
          ],
          filter: {
            id: {
              _in: selectedRowKeys
            }
          }
        })
      );

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const qrSize = 28;
      const itemsPerRow = 6;
      const textSpaceBelow = 19;
      const spaceBetween =
        (pageWidth - 2 * margin - itemsPerRow * qrSize) / (itemsPerRow - 1);

      let currentX = margin;
      let currentY = margin;
      let count = 0;

      for (const client of selectedClientsResponse) {
        const container = document.createElement("div");
        container.style.position = "absolute";
        container.style.left = "-9999px";
        document.body.appendChild(container);

        const root = ReactDOM.createRoot(container);
        root.render(
          <QRCode
            value={client.id}
            type="canvas"
            size={200}
            color="#000000"
            bgColor="#ffffff"
            bordered={false}
            icon="/logoeme.png"
          />
        );

        await new Promise((resolve) => setTimeout(resolve, 100));

        const canvas = container.querySelector("canvas");

        if (canvas) {
          if (currentY > pageHeight - margin - qrSize - textSpaceBelow) {
            pdf.addPage();
            currentY = margin;
            currentX = margin;
            count = 0;
          }

          const imgData = canvas.toDataURL("image/png");

          pdf.addImage(imgData, "PNG", currentX, currentY, qrSize, qrSize);

          pdf.setFontSize(4.5);

          const businessName1 = client.first_name || "";
          const businessName1Width =
            pdf.getStringUnitWidth(businessName1) * 6.5 * 0.352778;
          const businessName1X = currentX + qrSize / 2 - businessName1Width / 2;
          pdf.text(businessName1, businessName1X, currentY + qrSize + 4);

          const businessName2 = client.last_name || "";
          const businessName2Width =
            pdf.getStringUnitWidth(businessName2) * 6.5 * 0.352778;
          const businessName2X = currentX + qrSize / 2 - businessName2Width / 2;
          pdf.text(businessName2, businessName2X, currentY + qrSize + 8);

          count++;
          if (count >= itemsPerRow) {
            currentX = margin;
            currentY += qrSize + textSpaceBelow;
            count = 0;
          } else {
            currentX += qrSize + spaceBetween;
          }
        }

        root.unmount();
        container.remove();
      }

      pdf.save("codigos_qr.pdf");
      message.success(
        `PDF con ${selectedClientsResponse.length} códigos QR generado exitosamente`
      );
    } catch (error) {
      console.error("Error al generar el PDF:", error);
      message.error("Error al generar el PDF con códigos QR");
    } finally {
      setIsDownloading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    preserveSelectedRowKeys: true,
  };

  const handleSearchName = (value) => {
    setSearchName(value);
    getSellers(1, pagination.pageSize, filters, value);
  };

  const getSellers = async (
    page = 1,
    pageSize = 10,
    filters = {},
    searchNameValue = searchName
  ) => {
    if (!validarpermiso("directus_users", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    try {
      const directus = await getDirectusClient();

      const baseFilter = {
        role: { _eq: "fcc47285-a2a8-4722-ac38-7eee5dfb13d9" },

        ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
          ? { bodega: { id: { _eq: userBodega } } }
          : {}),
        ...(searchNameValue
          ? {
              _or: [
                { first_name: { _icontains: searchNameValue } },
                { last_name: { _icontains: searchNameValue } },
              ],
            }
          : {}),
        ...(filters.first_name
          ? { first_name: { _contains: filters.first_name } }
          : {}),
        ...(filters.last_name
          ? { last_name: { _contains: filters.last_name } }
          : {}),
        ...(filters.email ? { email: { _contains: filters.email } } : {}),
        ...(filters.documento
          ? { documento: { _contains: filters.documento } }
          : {}),
        ...(selectedCircuit
          ? {
              circuitos_clientes: {
                circuitos_id: {
                  id: { _eq: selectedCircuit },
                },
              },
            }
          : {}),
      };
      const countResponse = await directus.request(
        readUsers({
          aggregate: {
            countDistinct: ["id"],
          },
          filter: baseFilter,
        })
      );

      const total = countResponse[0]?.countDistinct?.id || 0;

      const res = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
            "role",
            "latitude",
            "longitude",
            "credito",
            "tope_credito",
            "dias_max_credito",
            "bodega.id",
            "bodega.nombre",
            "tipo_cliente",
            "celular",
            "telefono",
            "representante_legal",
            "total_personas",
            "encargado",
            "codigo_establecimiento",
            "circuitos_cliente.circuitos_id",
            "superior",
            "idremoto",
            "direccion",
          ],
          filter: baseFilter,
          limit: pageSize,
          page: page,
          sort: ["-first_name"],
        })
      );

      setDatasellers(res);
      setPagination({
        current: page,
        pageSize: pageSize,
        total: total,
      });
      setHasPermissionError(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      if (
        error.response?.status === 403 ||
        error.message?.includes("permission")
      ) {
        setHasPermissionError(true);
        message.error("No tiene permisos para ver los clientes");
      }
    }
  };

  const getVendors = async () => {
    try {
      const directus = await getDirectusClient();

      const res = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "circuitos_vendedor.id",
            "circuitos_vendedor.nombre",
            "circuitos_vendedor.ruta.id",
            "circuitos_vendedor.ruta.nombre",
            "circuitos_vendedor.clientes.clientes_id.*",
          ],
          filter: {
            role: {
              name: { _contains: "vendedor" },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: { id: { _eq: userBodega } },
                }
              : {}),
          },
        })
      );
      setVendors(res);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      message.error("Error al cargar los vendedores");
    }
  };

  const getRoutesByVendor = (vendorId) => {
    const vendor = vendors.find((v) => v.id === vendorId);
    if (vendor && vendor.circuitos_vendedor) {
      const seen = new Set();
      const uniqueRoutes = vendor.circuitos_vendedor
        .filter((c) => c.ruta && !seen.has(c.ruta.id) && seen.add(c.ruta.id))
        .map((c) => ({
          id: c.ruta.id,
          nombre: c.ruta.nombre,
        }));
      setRoutes(uniqueRoutes);
    } else {
      setRoutes([]);
    }
  };

  const getCircuitsByRoute = (vendorId, routeId) => {
    const vendor = vendors.find((v) => v.id === vendorId);
    if (vendor && vendor.circuitos_vendedor) {
      const circuits = vendor.circuitos_vendedor.filter(
        (c) => c.ruta && c.ruta.id === routeId
      );
      setCircuits(circuits);
    } else {
      setCircuits([]);
    }
  };

  const getAliados = async () => {
    try {
      const directus = await getDirectusClient();
      const res = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
            "role.name",
            "bodega.id",
            "superior"

          ],
          limit: -1,
          filter: {
            role: {
              name: { _eq: "Aliados" },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: { id: { _eq: userBodega } },
                }
              : {}),
          },
        })
      );
      setAliados(res);
    } catch (error) {
      console.error("Error fetching aliados:", error);
      message.error("Error al cargar los aliados");
    }
  };

  const handleAliadoChange = async (value) => {
    setSelectedAliado(value);
    setLoadingByAliado(true);
    try {
      if (value) {
        const response = await ObtenerUsuariosClientesPorSuperior(
          value,
          pagination.pageSize,
          pagination.current
        );
        setDatasellers(response);
        setFilteredClients(response);
      } else {
        // Si no hay aliado seleccionado, volver a cargar todos los clientes
        getSellers(1, pagination.pageSize, filters);
      }
    } catch (error) {
      console.error("Error al obtener usuarios por superior:", error);
      message.error("Error al cargar los clientes del aliado");
    } finally {
      setLoadingByAliado(false);
    }
  };

  useEffect(() => {
   
    getSellers(1, pagination.pageSize, filters);
  }, [selectedCircuit]);

  const filterClients = (vendorId, routeId, circuitId) => {
    try {
      if (!vendorId) {
        setFilteredClients(datasellers);
        return;
      }

      if (!datasellers || !Array.isArray(datasellers)) {
        console.error("datasellers no es un array válido");
        setFilteredClients([]);
        return;
      }

      const vendor = vendors.find((v) => v.id === vendorId);
      if (!vendor) {
        console.error("Vendedor no encontrado");
        setFilteredClients([]);
        return;
      }

      let filtered = [];

      if (vendor.circuitos_vendedor) {
        let circuitos = vendor.circuitos_vendedor;

        if (routeId) {
          circuitos = circuitos.filter((c) => c.ruta && c.ruta.id === routeId);
        }

        if (circuitId) {
          circuitos = circuitos.filter((c) => c.id === circuitId);
        }

        try {
          const clientIds = [
            ...new Set(
              circuitos.flatMap(
                (c) => c.clientes?.map((cl) => cl.clientes_id.id) || []
              )
            ),
          ];

          filtered = datasellers.filter((client) =>
            clientIds.includes(client.id)
          );
        } catch (error) {
          console.error("Error al procesar los IDs de clientes:", error);
          setFilteredClients([]);
          return;
        }
      }

      setFilteredClients(filtered);
    } catch (error) {
      console.error("Error en filterClients:", error);
      setFilteredClients([]);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getSellers(pagination.current, pagination.pageSize, filters);
  };

  const handleResetFilters = () => {
    setSelectedVendor(null);
    setSelectedRoute(null);
    setSelectedCircuit(null);
    setSearchName("");
    setFilters({});
    getSellers(1, pagination.pageSize, {});
  };

  useEffect(() => {
    getSellers();
    getVendors();
    getAliados();
  }, []);

  useEffect(() => {
    setFilteredClients(datasellers);
  }, [datasellers]);

  const closeCreate = () => {
    setOpencreate(false);
  };

  const closeUpdate = () => {
    setOpenupdate(false);
    setSelectseller(null);
  };

  const handleExportToExcel = async () => {
    try {
      // Preparar filtros basados en los filtros actuales
      const filters = {};
      
      // Agregar filtros de búsqueda por nombre si existe
      if (searchName) {
        filters._or = [
          { first_name: { _icontains: searchName } },
          { last_name: { _icontains: searchName } }
        ];
      }

      // Agregar filtros de bodega si el usuario no es admin
      if (userRoleID !== "adminapp" && userRoleID !== "Administrator") {
        filters.bodega = { id: { _eq: userBodega } };
      }

      await ExportClientsToExcel({
        setLoading: setIsExportingExcel,
        filters
      });
    } catch (error) {
      console.error("Error en exportación a Excel:", error);
    }
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      filterMode: "menu",
      filterSearch: true,
      onFilter: true,
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      filterMode: "menu",
      filterSearch: true,
      onFilter: true,
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
      filterMode: "menu",
      filterSearch: true,
      onFilter: true,
    },
    {
      title: "Documento",
      dataIndex: "documento",
      key: "documento",
      filterMode: "menu",
      filterSearch: true,
      onFilter: true,
    },
    {
      title: "Código QR",
      key: "qr",
      render: (_, record) => (
        <div id={`qr-${record.id}`}>
          <QRCode
            value={record.id}
            type="canvas"
            size={200}
            color="#000000"
            bgColor="#ffffff"
            style={{ marginBottom: 16 }}
            bordered={false}
            icon="/logoeme.png"
          />
        </div>
      ),
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("directus_users", "delete", permisos) && (
            <Button
              onClick={async () => {
                const directus = await getDirectusClient();
                Modal.confirm({
                  title: "Eliminar usuario",
                  icon: <ExclamationCircleFilled />,
                  content: "¿Desea eliminar este usuario?",
                  onOk() {
                    directus.request(deleteUser(record.id)).then(() => {
                      getSellers();
                    });
                  },
                });
              }}
            >
              Eliminar
            </Button>
          )}

          {validarpermiso("directus_users", "update", permisos) && (
            <Button
              onClick={() => {
                const selectedUser = {
                  ...record,
                };
                setSelectseller(selectedUser);
                setOpenupdate(true);
              }}
            >
              Editar
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layouts>
      {!hasPermissionError ? (
        <>
          <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Select
                placeholder="Seleccione un Aliado"
                style={{ width: "100%" }}
                allowClear
                onChange={handleAliadoChange}
                value={selectedAliado}
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  if (value) {
                    const filteredUsers = aliados.filter(user => 
                      `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())
                    );
                    setAliados(filteredUsers);
                  } else {
                    getAliados();
                  }
                }}
               

              >
                {aliados.map((aliado) => (
                  <Select.Option key={aliado.id} value={aliado.id}>
                    {`${aliado.first_name} `}
                    <span style={{ fontSize: "12px", color: "green" }}>
                      {aliado.role.name}
                    </span>
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Select
                placeholder="Seleccione un vendedor"
                style={{ width: "100%" }}
                allowClear
                onChange={(value) => {
                  setSelectedVendor(value);
                  setSelectedRoute(null);
                  setSelectedCircuit(null);
                  getRoutesByVendor(value);
                  filterClients(value, null, null);
                }}
                value={selectedVendor}
                disabled={!!selectedAliado}
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  if (value) {
                    const filteredUsers = vendors.filter(user => 
                      `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())
                    );
                    setVendors(filteredUsers);
                  } else {
                    getVendors();
                  }
                }}
              >
                {vendors.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {`${vendor.first_name} ${vendor.last_name}`}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Select
                placeholder="Seleccione una ruta"
                style={{ width: "100%" }}
                disabled={!selectedVendor}
                allowClear
                onChange={(value) => {
                  setSelectedRoute(value);
                  setSelectedCircuit(null);
                  getCircuitsByRoute(selectedVendor, value);
                  filterClients(selectedVendor, value, null);
                }}
                value={selectedRoute}
              >
                {routes.map((route) => (
                  <Select.Option key={route.id} value={route.id}>
                    {route.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Select
                placeholder="Seleccione un circuito"
                style={{ width: "100%" }}
                disabled={!selectedRoute}
                allowClear
                onChange={(value) => {
                  

                  setSelectedCircuit(value);
                  filterClients(selectedVendor, selectedRoute, value);
                }}
                value={selectedCircuit}
              >
                {circuits.map((circuit) => (
                  <Select.Option key={circuit.id} value={circuit.id}>
                    {circuit.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Input.Search
                placeholder="Buscar por nombre o apellido (sensible a mayúsculas)"
                allowClear
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                onSearch={handleSearchName}
                style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Button onClick={handleResetFilters} style={{ width: "100%" }}>
                Resetear filtros
              </Button>
            </Col>
          </Row>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>
            Mostrando{" "}
            {selectedCircuit ? filteredClients.length : datasellers.length}{" "}
            clientes
          </div>
          <Space direction="horizontal" style={{ marginBottom: 16 }}>
            {validarpermiso("directus_users", "create", permisos) && (
              <Button
                onClick={() => {
                  setOpencreate(true);
                }}
                disabled={hasPermissionError}
              >
                Crear cliente
              </Button>
            )}
            <Button
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={handleExportToExcel}
              disabled={hasPermissionError}
              loading={isExportingExcel}
            >
              {isExportingExcel ? "Exportando..." : "Exportar a Excel"}
            </Button>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={downloadSelectedQRs}
              disabled={selectedRowKeys.length === 0 || hasPermissionError}
              loading={isDownloading}
            >
              {isDownloading
                ? "Descargando QRs..."
                : "Descargar QRs seleccionados"}
            </Button>
          </Space>

          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={selectedCircuit ? filteredClients : datasellers}
            rowKey="id"
            pagination={pagination}
            onChange={handleTableChange}
            loading={loading}
          />

          {validarpermiso("directus_users", "create", permisos) && (
            <Createseller
              getSellers={getSellers}
              opencreate={opencreate}
              closeCreate={closeCreate}
            />
          )}

          {openupdate &&
            selectseller &&
            validarpermiso("directus_users", "update", permisos) && (
              <Editseller
                getSellers={getSellers}
                opencreate={openupdate}
                closeUpdate={closeUpdate}
                selectseller={selectseller}
                setSelectseller={setSelectseller}
              />
            )}
        </>
      ) : (
        <h3>No tiene permisos para ver clientes</h3>
      )}
    </Layouts>
  );
};

export default Clients;
